<template>
  <v-container
    fluid
    class="pa-0"
    :style="`width: 100vw; background: url(${require('../assets/background_04.jpg')}); background-size: cover; background-position: center center; background-attachment: fixed;`"
  >
    <v-row
      justify="center"
      justify-md="start"
      class="pl-0 pl-md-2 text-center text-md-left" 
      :style="`height: 100vh; background: url(${require('../assets/Startseite.jpg')}); background-size: cover; background-position: center center;`"
    >
      <v-col cols="12"></v-col>
      <v-col cols="12" md="1"></v-col>
      <v-col cols="12" md="6" lg="4" align-self="center">
        <v-row>
          <v-col cols="12">
            <h1
              class="text-uppercase font-weight-bold"
              style="font-size: 3em; text-shadow: 2px 2px 5px #FFF;"
            >ästhetischer Zahnersatz</h1>
            <h2 class="font-weight-light" style="text-shadow: 2px 2px 5px #FFF;">MADE IN GREVEN RECKENFELD</h2>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="12">
            <v-btn tile x-large color="red darken-4" dark class="mt-4" @click="$vuetify.goTo('#wir-designen', {duration: 800, easing: 'easeInOutQuad'});">Jetzt informieren</v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" align-self="end" class="text-center">
        <v-icon color="white" x-large>mdi-transfer-down</v-icon>
      </v-col>
    </v-row>
    <v-row
      id="wir-designen"
      justify="center"
      class="text-center"
      style="min-height: 50vh; background-color: rgba(183,28,28,0.9); color: #fff;"
    >
      <v-col cols="10" md="8" lg="6" align-self="center">
        <h1 style="font-size: 2.5em;">WIR DESIGNEN.</h1>
        <v-row justify="center" class="mt-5">
          <v-btn outlined tile large color="white" class="ma-2">
            <h2>Implantate</h2>
          </v-btn>
          <v-btn outlined tile large color="white" class="ma-2">
            <h2>Inlays</h2>
          </v-btn>
          <v-btn outlined tile large color="white" class="ma-2">
            <h2>Kronen</h2>
          </v-btn>
          <v-btn outlined tile large color="white" class="ma-2">
            <h2>Brücken</h2>
          </v-btn>
          <v-btn outlined tile large color="white" class="ma-2">
            <h2>Zirkondioxidkronen</h2>
          </v-btn>
          <v-btn outlined tile large color="white" class="ma-2">
            <h2>Zirkondioxidbrücken</h2>
          </v-btn>
          <v-btn outlined tile large color="white" class="ma-2">
            <h2>Schienen</h2>
          </v-btn>
          <v-btn outlined tile large color="white" class="ma-2">
            <h2>Veneer</h2>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      id="unser-service"
      style="min-height: 50vh; background-color: rgba(0,0,0,0.7); color: #fff; padding-top: 5vh; padding-bottom: 5vh;"
      justify="center"
    >
      <v-col cols="10" md="8" align-self="center">
        <h1 style="font-size: 2.5em;">UNSER SERVICE.</h1>
        <h3 class="mt-5">Wir bieten für Sie in Absprache mit Ihrem Zahnarzt folgende Leistungen:</h3>
        <v-list disabled color="transparent" dark>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;">unverbindliche Kostenplanung</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;"
              >Persönliche Betreuung und Beratung durch den Zahntechniker Meister</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;"
              >Patientenberatungsunterstützung (GoDent Modell / CD-ROM)</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;">Qualitätszertifikat für Patienten</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;">Eigener Kurierdienst</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;">Zahnersatzreiningung im Labor</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;">Allergietestproben</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;">Service an Ihrem Zahnersatz</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;"
              >Individuelle Charakterisierung mit Ihnen im Labor</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;"
              >Individuelle Farbbestimmung in der Praxis und im Labor</p>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tooth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="font-weight-bold" style="font-size: 1.2em;"
              >Aktivierung von Protesen (Lasertechnik zum verbessern des Haltes)</p>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row id="unser-labor" justify="center" style="background-color: #616161; color: #fff; min-height: 40vh; padding-top: 5vh; padding-bottom: 5vh;">
      <v-col cols="10" md="8">
        <h1 style="font-size: 2.5em;">UNSER LABOR.</h1>
        <h2 class="mt-5 text-left text-md-justify">
          Qualität und Vertrauenswürdigkeit, Präzision und Kontinuität sowie die enge Zusammenarbeit mit Ihrem anspruchsvollen Zahnarzt sind Leitmotive unseres Unternehmens bei der Herstellung Ihres Zahnersatzes. Unser Anliegen ist es, stets eine bedarfsgerechte Zahntechnik und Innovation zu bieten, ohne sich auf Material- und Technologieexperimente einzulassen.
          Ebenfalls möchten wir einen naturgetreuen und individuellen Zahnersatz für Sie herstellen.
        </h2>
        <v-row justify="center" style="margin-top: 5vh;">
          <v-col cols="12" md="6" align-self="center">
            <v-img src="../assets/j_seidel.jpg"></v-img>
          </v-col>
          <v-col cols="12" md="6" align-self="center">
            <h2>HISTORIE</h2>
            <p style="font-size: 1.1em;" class="text-md-justify">
              Nach der Ausbildung als Zahntechniker Meister gründete Jörg Seidel das Unternehmen am 01.09.1994 in Greven-Reckenfeld. Aus Platzmangel zog das Labor am 01.08.2005 in das DLZ (Dienstleistungszentrum) am Jägerweg 2-6 um. Hierbei wurde den stetig steigenden Anforderungen an Kapazität und Ausstattung Rechnung getragen.
              <br />
              <br />Dass die zahnärztlichen Kunden der ersten Stunde auch heute noch unsere Kunden sind, werten wir als besonderes Zeichen für eine erfolgreiche und partnerschaftliche Zusammenarbeit.
            </p>
          </v-col>
        </v-row>
        <v-row justify="center" style="margin-top: 5vh;">
          <v-col cols="12" md="6">
            <h2>QUALITÄT & VERTRAUEN</h2>
            <p style="font-size: 1.1em;" class="text-md-justify">
              <span style="font-weight-bold text-uppercase">"Die Herstellung von Medizinprodukten ist Vertrauenssache."</span> - Daher bildet die Qualitätssicherung einen großen Teil der Arbeit in unserem Labor. Als ein wichtiges Instrument der Qualitätssicherung ist das Meisterprinzip international anerkannt und führte zu einem weltweit führenden Standard aus deutschen Laboren.<br />
              <br />
              Ein wichtiger Anteil am optimalen Gelingen der zahntechnischen Lösungen ist unsere Unternehmens- und Personalpolitik. Des Weiteren kommen noch andere wirksame Qualitätsmanagementinstrumente zum Einsatz. So können zum Beispiel, für eine spätere Erweiterung des bestehenden Zahnersatzes, auch noch nach Jahren die eingesetzten Materialien patientenbezogen nachvollzogen werden.<br />
              <br />
              Auch die Einhaltung in Deutschland geltender Vorschriften im Arbeitsschutz- und Arbeitssicherheitsgesetz dient der Qualitätssicherung. Vor allem ist dies in indirekter und direkter Patientenarbeit notwendig, um zum Beispiel den Hygieneanforderungen gerecht zu werden. Die Einhaltung dieser Vorschriften wird dabei ständig von der „Berufsgenossenschaft für Feinmechanik und Elektrotechnik“ überwacht.
            </p>
          </v-col>
          <v-col cols="12" md="6">
            <v-img src="../assets/labor.jpg"></v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row id="unser-team" justify="center" style="background-color: #424242; color: #fff; min-height: 40vh; padding-top: 5vh; padding-bottom: 5vh;">
      <v-col cols="10" md="8">
        <h1 style="font-size: 2.5em;">UNSER TEAM.</h1>
      </v-col>
      <v-col cols="12"></v-col>
      <v-col cols="6" md="3" class="mx-md-2 text-center">
        <v-img src="../assets/j_seidel.jpg"></v-img>
        <h3 class="mt-2">Jörg Seidel</h3>
      </v-col>
      <v-col cols="6" md="3" class="mx-md-2 text-center">
        <v-img src="../assets/inawenselowski.jpg"></v-img>
        <h3 class="mt-2">Ina Wenselowski</h3>
      </v-col>
      <v-col cols="6" md="3" class="mx-md-2 text-center">
        <v-img src="../assets/AntoniaMeier.jpg"></v-img>
        <h3 class="mt-2">Antonia Meier</h3>
      </v-col>
      <v-col cols="6" md="3" class="mx-md-2 text-center">
        <v-img src="../assets/ManuelNiewerth.jpg"></v-img>
        <h3 class="mt-2">Manuel Niewerth</h3>
      </v-col>
      <v-col cols="6" md="3" class="mx-md-2 text-center">
        <v-img src="../assets/WenckeWalter.jpg"></v-img>
        <h3 class="mt-2">Wencke Walter</h3>
      </v-col>
    </v-row>
    <v-row id="kontakt" justify="center" style="background-color: #689F38; color: #fff; min-height: 40vh; padding-top: 5vh; padding-bottom: 5vh;">
     <v-col cols="10" md="5" lg="3">
        <h1 style="font-size: 2.5em;" class="mb-md-2">KONTAKT.</h1>
        <v-img src="../assets/Teamfoto2022.jpg"></v-img>
      </v-col>
      <v-col cols="11" md="7" lg="4" class="text-md-left text-center" align-self="end">
        <h2>WIR SIND FÜR SIE DA.</h2>
        <h3 class="mt-3"><v-icon class="mr-1">mdi-clock-time-eight</v-icon> Öffnungszeiten:<br><span class="font-weight-light">Montag bis Freitag, 08:00 - 18:00 Uhr</span></h3>
        <v-btn block tile outlined color="white" x-large class="my-4" href="https://www.google.de/maps/place/J%C3%B6rg+Seidel+Dentaldesign/@52.125182,7.5518384,17z/data=!3m1!4b1!4m5!3m4!1s0x47b9c9dc2b33e6e5:0xa676b4bd6416a18a!8m2!3d52.1251787!4d7.5540272" target="_blank">
          <v-icon class="mr-2">mdi-map-marker</v-icon> Jägerweg 2-6, 48268 Greven
        </v-btn>
        <v-btn block tile color="white" x-large class="my-4" href="tel:025751640">
          <v-icon class="mr-2">mdi-phone</v-icon> 02575 1640
        </v-btn>
        <v-btn block tile outlined color="white" large class="my-4" href="mailto:dentallabor-seidel@t-online.de">
          <v-icon class="mr-2">mdi-email</v-icon> dentallabor-seidel@t-online.de
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Start",
};
</script>
